// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-4k4rq38t78nx26bw6z9ccr6x17wy6ew8bvy8xqsuj923zgc6xdpfyqmtnwgcfpxzx7pxzxqxynwhuc17eebyjcwnz3kncyxnr35fre","loading":"loading-22aejzgfu898p83s626pbyd6jrwkdx8cn443mvm2qfvqt8vck97w3ae7utawwg9mmmn81d7njbxc64k2h1xn63qwctfpp2swravbfmc","pulse":"pulse-7yh9vgua8n3sc2qjd7j1yswt62gfxdp6dmrkdmhrykavcy72xgvn9ju31285zqmrb4czqpztubwpnxf943zszhqa2ppamc2qs6bpt5"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/components/Container/Container.module.scss
// module id = 762
// module chunks = 0